import system from './systemApis'
import policy from './policyApis'
import order from './orderApis'
import bill from './billApis'
import trade from './tradeApis'
import base from './baseApis'
import tour from './tourApis'
import flight from './flightApis'
import message from './messageApi'
import tourpolicy from './tourPolicyApi'
import flightpolicy from './flightPolicyApi'
import train from './trainApis'
import trainpolicy from './trainPolicyApi'
import hotelpolicy from './hotelPolicyApi'
import hotel from './hotelApi'
import btrip from './btripApi'
import work from './workApis'
import logs from './logsApis'
import invoice from './invoiceApis'
import express from './expressApis'
import insurancepolicy from './insurancePolicyApis'
import insurance from './insuranceApis'
import charge from './chargeapi'
import chargepolicy from './chargepolicyapi'
import side from './sideapi'
import statistics from "./statisticsApis";
import wechat from "./wechatApi";
import adapter from "./adapterApis"
import mall from './mallApis'
import activity from './activityApis'

import analyse from './analyseapi'
import huilianyi from './huilianyiapi'
import traffic from './trafficApi'
import trafficpolicy from './trafficPolicyApi'
import dingding from './dingdingapi'
export default {
    system,
    policy,
    order,
    bill,
    trade,
    base,
    tour,
    flight,
    message,
    tourpolicy,
    flightpolicy,
    train,
    trainpolicy,
    hotelpolicy,
    hotel,
    btrip,
    work,
    logs,
    invoice,
    express,
    insurancepolicy,
    insurance,
    charge,
    chargepolicy,
    side,
    statistics,
    wechat,
    adapter,
    mall,
    activity,
    analyse,
    huilianyi,
    traffic,
    trafficpolicy,
    dingding,
    getService(serviceCode) {
        if (serviceCode != undefined) {
            return this[serviceCode.toLowerCase().replace("service", "")];
        }
    }
}



// WEBPACK FOOTER //
// ./src/apis/index.js